/* @flow */
import * as React from 'react';

import Button from 'components/Button';
import Buttons from 'components/Buttons';

import type { Props as ButtonProps } from 'components/Button';

type ButtonCellInput = {
  fieldForAction: string,
  onClickAction: any => void,
  buttonLabel: React.Node,
  buttonProps: $Shape<ButtonProps>,
};

export function getButtonCellGenerator(input: ButtonCellInput) {
  return (data: Object) => {
    if (!input.buttonLabel) {
      return null;
    }

    return (
      <Button
        {...input.buttonProps}
        onClick={e => {
          e.stopPropagation();
          input.onClickAction(data[input.fieldForAction]);
        }}>
        {input.buttonLabel}
      </Button>
    );
  };
}

export function getButtonCellsGenerator(input: ButtonCellInput[]) {
  return (data: Object) => {
    return (
      <Buttons align="left">
        {input.map<React.Element>(cell => {
          return (
            <Button
              {...cell.buttonProps}
              onClick={e => {
                e.stopPropagation();
                cell.onClickAction(data[cell.fieldForAction]);
              }}>
              {cell.buttonLabel}
            </Button>
          );
        })}
      </Buttons>
    );
  };
}
